import controller_0 from '@symfony/ux-vue/dist/render_controller.js';
export default {
  'symfony--ux-vue--vue': controller_0,
};